module.exports = __webpack_public_path__ + "static/fonts/notokr-light.2ea9b0e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/relayevent/font/notokr-light.woff
// module id = Pkud
// module chunks = 0